import { render, staticRenderFns } from "./MaterialExamPapers.vue?vue&type=template&id=49ef572a"
import script from "./MaterialExamPapers.vue?vue&type=script&lang=js"
export * from "./MaterialExamPapers.vue?vue&type=script&lang=js"
import style0 from "./MaterialExamPapers.vue?vue&type=style&index=0&id=49ef572a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports